var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.66602V16.8327C5 17.6611 5.67157 18.3327 6.5 18.3327H13.5C14.3284 18.3327 15 17.6611 15 16.8327V6.66602H5Z",
    fill: "#DC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.667 3.75V3.5C11.667 2.94772 11.2193 2.5 10.667 2.5H9.33366C8.78137 2.5 8.33366 2.94772 8.33366 3.5V3.75H4.66699C4.39085 3.75 4.16699 3.97386 4.16699 4.25V4.5C4.16699 4.77614 4.39085 5 4.66699 5H15.3337C15.6098 5 15.8337 4.77614 15.8337 4.5V4.25C15.8337 3.97386 15.6098 3.75 15.3337 3.75H11.667Z",
    fill: "#DC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.166b4e9479873e02d91a5b4710844fd8.svg";
export { ForwardRef as ReactComponent };